// src/utils/sentryUtils.js
import * as Sentry from "@sentry/react";

export const logInfo = (message, data = {}) => {
  Sentry.addBreadcrumb({
    category: "info",
    message,
    data,
    level: "info",
  });
};

export const captureError = (error, context = {}) => {
  Sentry.withScope((scope) => {
    scope.setExtras(context);
    Sentry.captureException(error);
  });
};

export const captureEvent = (eventName, data = {}) => {
  Sentry.captureMessage(eventName, {
    level: "info",
    extra: data,
  });
};

// Hier stond een setUser die het e-mailadres en de naam van de gast aan Sentry meegaf. Dat werd
// door niemand aangeroepen, en het hoort ook niet: een gast die een tafel reserveert is geen
// gebruiker van een systeem waar je fouten aan koppelt. Weg gelaten in plaats van gerepareerd, want
// een functie die er staat wordt vroeg of laat gebruikt. (WI7, 13-09-2026)

/**
 * Wraps an async operation in a Sentry span for performance tracing.
 * Usage: const result = await withSpan("widget.load", () => fetchWidgetData(key));
 */
export const withSpan = async (name, operation, attributes = {}) => {
  return Sentry.startSpan({ name, attributes }, () => operation());
};

/**
 * Records a user action breadcrumb (button clicks, form submits, navigation steps).
 */
export const logUserAction = (action, data = {}) => {
  Sentry.addBreadcrumb({
    category: "user.action",
    message: action,
    data,
    level: "info",
  });
};

/**
 * Records a navigation breadcrumb for widget step changes.
 */
export const logNavigation = (from, to, data = {}) => {
  Sentry.addBreadcrumb({
    category: "navigation",
    message: `${from} → ${to}`,
    data,
    level: "info",
  });
};